﻿import { useEffect, useMemo, useState } from 'react';
import { ROUTES } from '@/config/routes';
import { getWebsitePolicy } from '@/services/api/website-policy.service';

const FALLBACK_PRIVACY_TITLE = 'Privacy Policy';
const FALLBACK_TERMS_TITLE = 'Terms & Conditions';

export function usePolicyLinks() {
  const [privacyTitle, setPrivacyTitle] = useState(FALLBACK_PRIVACY_TITLE);
  const [termsTitle, setTermsTitle] = useState(FALLBACK_TERMS_TITLE);

  useEffect(() => {
    let alive = true;

    Promise.all([
      getWebsitePolicy('privacy'),
      getWebsitePolicy('terms'),
    ])
      .then(([privacy, terms]) => {
        if (!alive) return;
        setPrivacyTitle(privacy?.title || FALLBACK_PRIVACY_TITLE);
        setTermsTitle(terms?.title || FALLBACK_TERMS_TITLE);
      })
      .catch(() => undefined);

    return () => { alive = false; };
  }, []);

  return useMemo(() => ({
    privacy: { label: privacyTitle, href: ROUTES.PRIVACY },
    terms: { label: termsTitle, href: ROUTES.TERMS },
    links: [
      { label: privacyTitle, href: ROUTES.PRIVACY },
      { label: termsTitle, href: ROUTES.TERMS },
    ],
  }), [privacyTitle, termsTitle]);
}

